import { render, staticRenderFns } from "./BlockNegative.vue?vue&type=template&id=25d7fa8e&scoped=true"
import script from "./BlockNegative.vue?vue&type=script&lang=js"
export * from "./BlockNegative.vue?vue&type=script&lang=js"
import style0 from "./BlockNegative.vue?vue&type=style&index=0&id=25d7fa8e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d7fa8e",
  null
  
)

export default component.exports